export default __webpack_public_path__ + "images/F9.8bd3597.png";